export function CoreCurrencyDirective (sessionObjAPI) {

  function getSettings () {
    var settings = sessionObjAPI.currency();

    settings.NUMBER_REGEXP = new RegExp(settings.validation);

    return settings;
  }

  function isUndefined(value) {
    return typeof value == 'undefined';
  }

  function isEmpty(value) {
    return isUndefined(value) || value === '' || value === null || value !== value;
  }

  function round(num, pow) {
    return Math.round(num * (Math.pow(10, pow))) / Math.pow(10, pow);
  }

  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      onBlur: '&'
    },
    link: function (scope, el, attr, ctrl) {
      var min      = parseFloat(attr.min) || 0;
      var max      = parseFloat(attr.max);
      var rounding = parseInt(attr.round) || 2;

      function maskValue (value) {

        // Split up the amount and the decimal amount
        var x = value.toString().split('.');
        var rgx = /(\d+)(\d{3})/;
        var settings = getSettings();

        // Format larger numbers by adding thousands separator
        while (rgx.test(x[0])) {
          x[0] = x[0].replace(rgx, '$1' + settings.thousands_separator + '$2');
        }

        // If the decimal value is 0 AND we want to round the value, then remove the decimal value
        if (!x[1] || x[1] === '0' || x[1] === '00' || x[1] === 0 && attr.round) {
          x[1] = '';
        }

        // If there is no decimal value and we dont want to round, set it to double zero
        else if (!x[1] || x[1] == "") {
          x[1] = '00';
        }

        // If the decimal value length is only one (i.e. 12.2) then add a zero to format
        else if (x[1].length == 1) {
          x[1] = x[1] + '0';
        }

        // Some countries don't have decimals when it comes to currency, so cut it off
        else if (settings.no_currency_fractions) {
          x[1] = '';
        }

        return x[0] + (x[1] ? settings.decimal_mark + x[1] : '');
      }

      function minValidator (value) {
        if (!isEmpty(value) && value < min) {
          ctrl.$setValidity('min', false);
          return undefined;
        } else {
          ctrl.$setValidity('min', true);
          return value;
        }
      }

      function maxValidator (value) {
        if (!isEmpty(value) && value > max) {
          ctrl.$setValidity('max', false);
          return undefined;
        } else {
          ctrl.$setValidity('max', true);
          return value;
        }
      }

      function handleBlur () {
        var value = ctrl.$modelValue;

        if (scope.onBlur) {
          scope.onBlur();
        }

        if (value) {
          ctrl.$viewValue = maskValue(value);
          ctrl.$render();
        }
      }

      ctrl.$parsers.push(value => {
        var settings = getSettings();

        value = isUndefined(value) ? '': value;

        // first replace switch all commas and decimal if the country calls for it
        value = value.replace(/[\.,]/g, m => {
          return m == '.' ? settings.decimal_mark : settings.thousands_separator;
        });

        // then get rid of any commas to convert to float correctly
        value = value.replace(/,/g, '');

        // Handle leading decimal point, like ".5"
        if (value === '.') {
          ctrl.$setValidity('number', true);
          return 0;
        }

        // Allow "-" inputs only when min < 0
        if (value === '-') {
          ctrl.$setValidity('number', false);
          return (min < 0 ) ? -0 : NaN;
        }

        var empty = isEmpty(value);

        if (empty || settings.NUMBER_REGEXP.test(value)) {
          ctrl.$setValidity('number', true);

          // If the country settings tell us to cut off the decimal, do it here
          return empty ? '' : (settings.no_currency_fractions ? parseInt(value) : parseFloat(value));
        }

        ctrl.$setValidity('number', false);
        return NaN;

      });

      ctrl.$formatters.push(value => {
        return isEmpty(value) ? '' : '' + value;
      });

      ctrl.$parsers.push(minValidator);
      ctrl.$formatters.push(minValidator);

      if (attr.max) {
        ctrl.$parsers.push(maxValidator);
        ctrl.$formatters.push(maxValidator);
      }

      // Round off to 2 decimal places
      ctrl.$parsers.push(value => {
        return value ? round(value, rounding) : 0;
      });

      ctrl.$formatters.push(value => {
        var settings = getSettings();
        var value = ctrl.$modelValue;

        if (value) {
          var maskedValue =  maskValue(value);

          return maskedValue.replace(/[\.,]/g, m => {
            return m == '.' ? settings.decimal_mark : settings.thousands_separator;
          });
        }
      });

      el.on('blur', handleBlur);

      scope.$on('$destroy', () => {
        el.off('blur', handleBlur);
      });
    }
  };
}